export const showHideSubscriptionModal = (accessToken, closeModal) => {
  if (closeModal) {
    closeModal()
  }
  // const domain = process.env.NODE_ENV === 'production' && process.env.__NOTIFICATION_ENV__ == 'production' ? 'basemap' : 'staging2.basemap'
  //  const domain = 'basemap'
  // Production builds go to the live purchase site; every non-production build
  // (staging/dev) goes to the staging/test purchase site.
  // NOTE: the previous logic compared NODE_ENV against 'dev'/'purchase', but
  // webpack only ever sets process.env.NODE_ENV to 'development' or 'production'
  // (from `mode`), so BOTH staging and prod builds fell through to 'purchase' —
  // i.e. staging upgrades were sent to the LIVE purchase site. This fixes that
  // while leaving production ('purchase') unchanged.
  const env = process.env.NODE_ENV === 'production' ? 'purchase' : 'staging-purchase'

  window.open(`https://${env}.basemap.com/?ref=webapp&token=${accessToken}`)
}